import logo from './logo.svg';
import './Loader.css'

export const Loader = ({ children }) => {
  return (
    <img src={logo} className="App-logo" alt="logo" />
  );
};
